export default function debitNotesReducer(state = {
    newDebitNotes: false,
    debitNotesList: {
        fetching: false,
        fetched: false
    },
    debitNotesTotalData: {
        fetching: false,
        fetched: false
    }
}, action) {
    switch (action.type) {
        case "NEW_DEBIT_NOTES": {
            return {
                ...state,
                newDebitNotes: action.newDebitNotes
            }
        }
        case "DEBIT_NOTES_LIST_PENDING": {
            return {
                ...state,
                debitNotesList: {
                    fetching: true,
                    fetched: false
                }
            }
        }
        case "DEBIT_NOTES_LIST_REJECTED": {
            return {
                ...state,
                debitNotesList: {
                    fetching: false,
                    fetched: false
                }
            }
        }
        case "DEBIT_NOTES_LIST_FULFILLED": {
            return {
                ...state,
                debitNotesList: {
                    fetching: false,
                    fetched: true
                }
            }
        }
        case "DEBIT_NOTES_TOTAL_DATA_PENDING": {
            return {
                ...state,
                debitNotesTotalData: {
                    fetching: true,
                    fetched: false
                }
            }
        }
        case "DEBIT_NOTES_TOTAL_DATA_REJECTED": {
            return {
                ...state,
                debitNotesTotalData: {
                    fetching: false,
                    fetched: false
                }
            }
        }
        case "DEBIT_NOTES_TOTAL_DATA_FULFILLED": {
            return {
                ...state,
                debitNotesTotalData: {
                    fetching: false,
                    fetched: true
                }
            }
        }
        default : {
            return state
        }
    }
}
